import * as React from 'react';
import { Component } from 'react';
import './Loader.css';


interface IProps {
    Visible: boolean,
    Key?: string //Należy używać w przypadku kilku loaderów na stronie
}

interface IState {
    Width?: string,
    Height?: string,
    Padding?: string
}

export class LoaderComponent extends Component<IProps, IState> {
    
    private LoaderRef = React.createRef<HTMLDivElement>();

    constructor(props) {
        super(props);

        this.state = {}

        this.InitLoaderSize = this.InitLoaderSize.bind(this);
    }

    public componentDidMount() {
        this.InitLoaderSize();
    }

    public componentWillReceiveProps(nextProps: IProps) {
        this.InitLoaderSize();
    }

    public render() {
        let loaderContainer: JSX.Element | null = null;
        if (this.props.Visible) {
            loaderContainer = (
                <div className="loader-container"
                    style={{
                        width: this.state.Width ? this.state.Width : '0px',
                        height: this.state.Height ? this.state.Height : '0px',
                        padding: this.state.Padding ? this.state.Padding : '0px'
                    }}>
                    <svg
                        className="loader"
                        width="57"
                        height="57"
                        viewBox="0 0 57 57"
                        xmlns="http://www.w3.org/2000/svg"
                        stroke="#fff">
                        <g fill="none" fillRule="evenodd">
                            <g transform="translate(1 1)" strokeWidth="2">
                                <circle cx="5" cy="50" r="5">
                                    <animate attributeName="cy"
                                        begin="0s" dur="2.2s"
                                        values="50;5;50;50"
                                        calcMode="linear"
                                        repeatCount="indefinite" />
                                    <animate attributeName="cx"
                                        begin="0s" dur="2.2s"
                                        values="5;27;49;5"
                                        calcMode="linear"
                                        repeatCount="indefinite" />
                                </circle>
                                <circle cx="27" cy="5" r="5">
                                    <animate attributeName="cy"
                                        begin="0s" dur="2.2s"
                                        from="5" to="5"
                                        values="5;50;50;5"
                                        calcMode="linear"
                                        repeatCount="indefinite" />
                                    <animate attributeName="cx"
                                        begin="0s" dur="2.2s"
                                        from="27" to="27"
                                        values="27;49;5;27"
                                        calcMode="linear"
                                        repeatCount="indefinite" />
                                </circle>
                                <circle cx="49" cy="50" r="5">
                                    <animate attributeName="cy"
                                        begin="0s" dur="2.2s"
                                        values="50;50;5;50"
                                        calcMode="linear"
                                        repeatCount="indefinite" />
                                    <animate attributeName="cx"
                                        from="49" to="49"
                                        begin="0s" dur="2.2s"
                                        values="49;5;27;49"
                                        calcMode="linear"
                                        repeatCount="indefinite" />
                                </circle>
                            </g>
                        </g>
                    </svg>
                </div>
            );
        }
        return (
            <div className="loader-component" ref={this.LoaderRef}>
                {loaderContainer}
            </div>
        );
    }

    private OnParentChange(evt) {
    }

    private InitLoaderSize() {
        if (this.LoaderRef.current !== null && this.LoaderRef.current.parentElement !== null) {
            this.LoaderRef.current.parentElement.addEventListener('change', this.OnParentChange, false);
            if (this.state.Width !== (this.LoaderRef.current.parentElement.clientWidth + 'px') ||
                this.state.Height !== (this.LoaderRef.current.parentElement.clientHeight + 'px')
            ) {
                this.setState({
                    Width: (this.LoaderRef.current.parentElement.clientWidth + 'px'),
                    Height: (this.LoaderRef.current.parentElement.clientHeight + 'px'),
                    Padding: (
                        ((this.LoaderRef.current.parentElement.clientWidth + this.LoaderRef.current.parentElement.clientHeight) / 20) + 'px'
                    ) 
                });
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/controls/Loader.tsx